<template>
  <div class="table-wrapper shadow-muted-super mt-2" ref="headerSummarySection">
    <b-overlay :show="isLoading" rounded="sm" spinner-variant="primary" opacity="0.6">
      <b-table
        @row-selected="onRowSelected"
        selectable
        :fields="visibleFields"
        :items="items"
        ref="theTable"
        class="bg-white shadow-muted-super sum-header mb-0"
        head-variant="light"
        no-border-collapse
        small
        :sticky-header="tableHeight"
        :filter="AppState.cnrSearchText"
        show-empty
        @row-clicked="item => $router.push('/risks/' + item.DbId)"
        tbody-tr-class="action-button"
        :filter-included-fields="['Description']"
        @filtered="filteredItems => recalcSumHeaders(filteredItems)"
      >
        <template #head(checked)>
          <b-form-checkbox
            :disabled="items.length == 0"
            v-model="checkedAllTableEntries"
            @change="onCheckAllTableEntries"
          ></b-form-checkbox>
        </template>
        <template #head(actions)="data">
          {{ data.label }}
          <span @click="$bvModal.show('risksProjectList')" role="button">
            <b-icon icon="three-dots-vertical" class="float-right no-outline" style="margin-top: 4px" />
          </span>
          <!--
          <b-modal
            cancel-disabled
            ok-disabled
            hide-footer
            hide-backdrop
            hide-header
            no-fade
            id="column-selector-modal"
            body-class="p-0"
            content-class="border-0"
          >
            <b-list-group>
              <b-list-group-item v-for="item in fields.filter(x => x.hideable == true)" :key="item.key" class="p-2">
                <b-form-checkbox
                  @change="onClickColumnVisible(item)"
                  v-model="item.visible"
                  value="true"
                  unchecked-value="false"
                >
                  {{ item.label }}
                </b-form-checkbox>
              </b-list-group-item>
            </b-list-group>
          </b-modal> -->
        </template>
        <template #cell(checked)="data">
          <b-form-checkbox
            @change="checked(data)"
            v-model="data.rowSelected"
            :disabled="data.item.editMode"
          ></b-form-checkbox>
        </template>
        <template #cell(actions)="data">
          <b-icon
            class="action-button text-grey"
            style="width: 18px; height: 18px"
            icon="arrow-right"
            title="Chancen & Risiken"
            @click.stop="$router.push('/risks/' + data.item.DbId)"
          />
          <b-icon
            icon="trash"
            variant="grey"
            class="action-button ml-2"
            style="width: 16px; height: 16px"
            title="Beleg löschen"
            @click.stop="deleteRecord(data.item)"
            v-if="$root.$user.isPlaner || $root.$user.isAdmin"
          />
        </template>
        <template #head(AmountChance)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              <small>{{ data.label }}</small>
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText !== '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText !== ''" />
              {{ $utils.formatCurrency(SumAmountChance, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(AmountRisiko)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              <small>{{ data.label }}</small>
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText !== '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText !== ''" />
              {{ $utils.formatCurrency(SumAmountRisiko, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(AmountChanceProg)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              <small>{{ data.label }}</small>
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText !== '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText !== ''" />
              {{ $utils.formatCurrency(SumAmountChanceProg, SettingsStore) }}
            </div>
          </div>
        </template>
        <template #head(AmountRisikoProg)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              <small>{{ data.label }}</small>
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText !== '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText !== ''" />
              {{ $utils.formatCurrency(SumAmountRisikoProg, SettingsStore) }}
            </div>
          </div>
        </template>
        <!--
        <template #head(AmountTotalProg)="data">
          <div style="padding-right: 2px" class="text-muted">
            <div style="padding-right: 2px">
              <small>{{ data.label }}</small>
              aaa
            </div>
            <div
              class="font-weight-bold text-right text-grey text-nowrap"
              :class="{ 'text-primary': AppState.cnrSearchText !== '' }"
            >
              <b-icon icon="funnel-fill" v-if="AppState.cnrSearchText !== ''" />
              {{ $utils.formatCurrency(data.field.sum, SettingsStore) }}
            </div>
          </div>
        </template>-->
      </b-table>
    </b-overlay>
    <TableColumnSelector
      :fields="fields"
      id="risksProjectList"
      @ok="AppState.updateVisibleFields('risksProjectList', fields)"
    ></TableColumnSelector>
  </div>
</template>

<script>
import AppState from '@/store/App.js';
import SettingsStore from '@/store/Settings';
import RisksService from '@/service/RisksService';
import TableColumnSelector from '@/components/TableColumnSelector';

export default {
  async activated() {
    AppState.loadVisibleFields('risksProjectList', this.fields);
    AppState.cnrSearchText = AppState.cnrSearchTextProject;

    AppState.isLoading = false;
    this.isLoading = true;
    this.$eventBus.$emit('CnR:filterReset', this.filterEnabled);
    this.items = await RisksService.getAllProject();

    window.addEventListener('resize', this.onWindowResize);
    this.onWindowResize();

    this.$eventBus.$on('CnR:header:toggle', this.onWindowResize);
    this.$eventBus.$on('CnR:filter', this.handleFilter);

    this.$eventBus.$emit('CnR:rowsSelected', this.selectedRows);

    if (this.selectedRows.length > 0 && this.filterEnabled) {
      this.items = this.selectedRows;
      this.$refs.theTable.selectAllRows();
    } else {
      this.$refs.theTable.clearSelected();

      this.selectedRows.forEach(row => {
        this.$nextTick(() => {
          this.$refs.theTable.selectRow(this.items.findIndex(item => row.DbId == item.DbId));
        });
      });
    }

    this.recalcSumHeaders(this.items);
    this.$nextTick(() => (this.isLoading = false));
  },
  deactivated() {
    AppState.cnrSearchTextProject = AppState.cnrSearchText;
    this.$eventBus.$off('CnR:filter', this.handleFilter);
  },
  components: {
    TableColumnSelector
  },
  data() {
    return {
      isLoading: true,
      SettingsStore,
      AppState,
      searchText: '',
      selectedRows: [],
      checkedAllTableEntries: false,
      filterEnabled: false,
      tableHeight: '500px',
      SumAmountChance: 0.0,
      SumAmountChanceProg: 0.0,
      SumAmountRisiko: 0.0,
      SumAmountRisikoProg: 0.0,
      fields: [
        {
          hideable: false,
          visible: true,
          key: 'checked',
          label: '',
          tdClass: 'sticky-col first-col text-center align-middle',
          thClass: 'sticky-col first-col text-center align-top noselect',
          thStyle: 'z-index: 10;'
        },
        {
          visible: true,
          hideable: false,
          key: 'Datum',
          label: 'Datum',
          thClass: 'align-top sticky-col second-col',
          tdClass: 'sticky-col second-col',
          sortable: true,
          thStyle: 'z-index: 10;',
          formatter: x => this.$utils.SQLDateToGermanDate(x)
        },
        {
          visible: true,
          hideable: false,
          key: 'Description',
          label: 'Bezeichnung',
          thClass: 'align-top sticky-col third-col',
          tdClass: 'sticky-col third-col',
          sortable: true,
          thStyle: 'z-index: 10;'
        },
        {
          hideable: true,
          visible: true,
          key: 'AmountChance',
          label: 'Chancen',
          thClass: 'align-top text-right',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          //sumHeader: true,
          //sum: 0.0,
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'AmountChanceProg',
          label: '(C-prognoserelevant)',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          //sumHeader: true,
          //sum: 0.0,
          thClass: 'align-top text-right text-nowrap',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'AmountRisiko',
          label: 'Risiken',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          //sumHeader: true,
          //sum: 0.0,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'AmountRisikoProg',
          label: '(R-prognoserelevant)',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          //sumHeader: true,
          //sum: 0.0,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          formatter: x => this.$utils.formatCurrency(x, SettingsStore)
        },
        /*
        {
          hideable: true,
          visible: true,
          key: 'AmountTotal',
          label: 'Gesamt',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          formatter: (k, v, item) => this.$utils.formatCurrency(item.AmountRisiko - item.AmountChance, SettingsStore)
        },
        {
          hideable: true,
          visible: true,
          key: 'AmountTotalProg',
          label: '(prognoserelevant)',
          tdClass: 'bg-light text-right text-nowrap',
          sortable: true,
          thClass: 'align-top text-right',
          thStyle: 'padding-right: 12px;',
          formatter: (k, v, item) =>
            this.$utils.formatCurrency(item.AmountRisikoProg - item.AmountChanceProg, SettingsStore)
        },*/
        {
          hideable: false,
          visible: true,
          key: 'actions',
          label: 'Aktionen',
          tdClass: 'sticky-col last-col text-center align-middle',
          thClass: 'sticky-col last-col align-top noselect',
          thStyle: 'z-index: 10'
        }
      ],
      items: []
    };
  },
  methods: {
    deleteRecord(item) {
      this.$bvModal
        .msgBoxConfirm('Soll der Eintrag "' + item.Description + '" wirklich gelöscht werden?', {
          title: 'Projekt Chance/Risiko löschen',
          okTitle: 'Bestätigen',
          cancelTitle: 'Abbrechen',
          okVariant: 'danger',

          centered: true
        })
        .then(confirmed => {
          if (confirmed) {
            RisksService.delete(item)
              .then(() => {
                this.$showSuccess(this, 'Chance/Risiko löschen', 'Chance/Risiko erfolgreich gelöscht');
                this.recalcSumHeaders(this.items);
                this.$eventBus.$emit('CnR:deleted');
              })
              .catch(err => {
                if (err.response) this.$showError(this, err.response.data);
                else this.$showError(this, err.toString());
              });
            this.$utils.deleteItemFromArray(this.items, x => x.DbId == item.DbId);
          }
        });
    },
    recalcSumHeaders(items) {
      this.SumAmountChance = 0.0;
      this.SumAmountChanceProg = 0.0;
      this.SumAmountRisiko = 0.0;
      this.SumAmountRisikoProg = 0.0;
      items.map(item => {
        this.SumAmountChance += item.AmountChance;
        this.SumAmountChanceProg += item.AmountChanceProg;
        this.SumAmountRisiko += item.AmountRisiko;
        this.SumAmountRisikoProg += item.AmountRisikoProg;
      });
    },
    onWindowResize() {
      setTimeout(() => {
        const totalHeight = window.innerHeight;
        const headerSummarySection = this.$refs.headerSummarySection;
        //const headerHeight = this.$refs.pageHeader.offsetHeight;
        const tableHeight = totalHeight - headerSummarySection.offsetHeight - 115;
        this.tableHeight = tableHeight + 'px';
      }, 300);
    },
    checked(data) {
      if (data.rowSelected) {
        this.$refs.theTable.selectRow(data.index);
      } else {
        this.$refs.theTable.unselectRow(data.index);
      }
    },
    onRowSelected(selectedItems) {
      this.selectedRows = selectedItems;
      this.$eventBus.$emit('CnR:rowsSelected', this.selectedRows);
      if (selectedItems.length < this.items.length) {
        this.checkedAllTableEntries = false;
      } else {
        this.checkedAllTableEntries = true;
      }
    },
    onCheckAllTableEntries() {
      if (this.checkedAllTableEntries) {
        this.$refs.theTable.selectAllRows();
      } else {
        this.$refs.theTable.clearSelected();
      }
    },
    handleFilter(filterEnabled) {
      this.filterEnabled = filterEnabled;
      if (filterEnabled) {
        this.itemsBackup = [...this.items];
        this.items = this.selectedRows;
        this.$nextTick(() => {
          this.$refs.theTable.selectAllRows();
        });
      } else {
        this.items = this.itemsBackup;
      }
      this.recalcSumHeaders(this.items);
    }
  },
  computed: {
    visibleFields() {
      return this.fields.filter(field => field.visible == true || field.visible == 'true');
    }
  }
};
</script>

<style>
#column-selector-modal > .modal-dialog {
  position: absolute;
  top: 340px;
  right: 13px;
}
</style>
